/***
 * 创建人：李珊
 * 时间：2020-12-01
 * 描述: 素材高级检索
 * 使用说明:
 * 更新说明:
 */
import { Component, OnInit, ViewChild } from '@angular/core';
import { SwMassageBoxService } from '../../../../librarys/serves/sw-massage-box.service';
import { SwGridTableComponent } from '../../../../librarys/components/basic-components/sw-table/sw-grid-table/sw-grid-table.component';
import { KmsService } from '../../kms.service';
import { Router } from '@angular/router';
import { KmsEnum } from '../../serves/kms-enum';
import { environment } from 'src/environments/environment';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { SwMaskService } from 'src/app/librarys/components/basic-components/sw-mask/sw-mask.service';
import { GetUserModelService } from 'src/app/librarys/serves/public/get-user-model.service';
import { MaterialViewComponent } from '../material-manage/material-view/material-view.component';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { InstanceModuleService } from '../../serves/instance/instance.module';

declare var $;

@Component({
  selector: 'app-advanced-search',
  templateUrl: './advanced-search.component.html',
  styleUrls: ['./advanced-search.component.css']
})
export class AdvancedSearchComponent implements OnInit {
  // 表格组件
  @ViewChild("swtable") swtable: SwGridTableComponent;
  // 当前登录用户id
  userId: string;
  // 素材名称默认：搜索类型
  matchPattern: any = 0;
  isTextSearch = false;
  // 搜索类型类型下拉选项
  matchPatterns: any = [
    { id: 0, text: '模糊' },
    { id: 1, text: '精确' },
  ];
  // 与或非
  yesAndno = [
    { id: 0, text: 'AND' },
    { id: 1, text: 'OR' },
    { id: 2, text: 'NOT' },
  ]; 
  // 选中文本类型
  textType:any = ''; 
  // 素材文本类型下拉选项
  textTypeOptions:any = []; 
  // 搜索属性下拉选项  
  attrTypeOptions = [];   
  // 搜索结果
  datas: any[] = []; 
  // 初始化表单项数据
  formRows = [
    {
      withType: this.yesAndno[0].id, // 默认选中第一项
      code: '', // 默认选中第一项
      keyWord: '',
      matchPattern: this.matchPatterns[0].id // 默认选中第一项
    }
  ];
  // 素材名称
  materialTitle: any = '';
  // 上一次查询条件
  lastQueryParams:any = {}; 
  // 是否显示正在加载
  isLoading = false;
  checkedData = []; //选中的内容
  // 分页参数
  pageBase: any = {
    current: 1,
    size: 10
  }
  isInit = true;
  fileCategoryOptions = [];
  constructor(
    private kmsService: KmsService,
    private box:SwMassageBoxService,
    private swMaskService: SwMaskService,
    private jwt: SwJwtService,
    private router: Router,
    private User: GetUserModelService,
    private create: SwCreateModalComponentService,
    private instanceModuleService: InstanceModuleService) {
  }

  ngOnInit() {
    // 获取用户id
    let user = this.User.getUser();
    this.userId = user['userId'];
    // 获取分类数据
    this.fileCategoryOptions = this.instanceModuleService.getResourceTypeOptions();
    this.textTypeOptions = this.fileCategoryOptions.find((item) => item.id === "FILE_TYPE_DOCUMENT").childs;
    this.attrTypeOptions = JSON.parse(JSON.stringify(this.textTypeOptions[0].recordFileds));
    this.attrTypeOptions.unshift({
      id: 'tags',
      text: '研究主题'
    });
    this.formRows[0].code = this.attrTypeOptions[0].id;
    this.textType = this.textTypeOptions[0].id;
  }

  //enter键触发搜索
  enterSearch(event) {
    if (event.keyCode == '13') {
      this.clickSelect();
    }
  }

  // 查询方法
  clickSelect() {
    let materialTitle = $.trim(this.materialTitle);
    let attrs:any = this.formRows.filter(item => $.trim(item.keyWord));
    if(!materialTitle && attrs.length <= 0){
      this.box.danger('请设置搜索条件！');
      return;
    }else{
      this.isInit = false;
      this.lastQueryParams = {
        materialTitle: materialTitle,
        matchPattern: this.matchPattern,
        attrs: attrs,
        textType: this.textType
      }
      this.isTextSearch = this.lastQueryParams.attrs.filter(e => e.code == 'allText').length > 0;
      this.pageBase = {
        current: 1, 
        size: 10
      };
      this.getData();
    }
  }

  // 选择文本类型
  clickRadio(item) {
    this.attrTypeOptions = JSON.parse(JSON.stringify(item.recordFileds));
    this.attrTypeOptions.unshift({
      id: 'tags',
      text: '研究主题'
    });
    this.formRows = [
      {
        withType: this.yesAndno[0].id, // 默认选中第一项
        code: this.attrTypeOptions[0].id, // 默认选中第一项
        keyWord: '',
        matchPattern: this.matchPatterns[0].id // 默认选中第一项
      }
    ];
    this.textType = item.id;
    this.clickSelect();
  }

  // 点击添加到提取任务
  handleAddClick() {
    if (this.checkedData.length <= 0) {
      this.box.danger('请至少选择一条数据！');
      return;
    } else {
      this.swMaskService.openMask('正在保存数据，请稍候...');
      // 查询当前用户已添加到历史记录中的资源
      const params = {
        current: 1,
        size: 1000,
        userId: this.userId
      }
      this.kmsService.queryExtractResourceList(params).subscribe((res) => {
        if(res["code"] == "200"){
          // 获取当前用户已添加到历史记录中的资源 与 当前选中的资源进行合并
          // 判断是否为全文检索，全文检索需按页码合并；非全文检索，按materialId进行合并
          if(this.isTextSearch){
            this.mergeData(res.data.records);
          }else{
            this.mergeData2(res.data.records);
          }
        }else{
          this.swMaskService.closeMask();
          this.box.waring(res.msg);
        }
      });
    }
  }

  // 全文检索时：合并数据
  mergeData(oldDatas) {
    // 新选择的数据
    let newData = [];
    this.checkedData.forEach(e => {
      const i = parseInt(e);
      newData.push({
        materialId: this.datas[i].materialId,
        pagesNum: this.datas[i].pagesNum+''
      })
    })
    let res = oldDatas;
    for (let i = 0; i < newData.length; i++) {
      let on = false;
      if(res.length > 0){
        res.forEach(e => {
          // 判断是否选择该资源
          if(e.materialId == newData[i].materialId){
            on = true;
            if(e.pagesNum){
              // 判断是否选择该资源的该页
              const arr = e.pagesNum.split(',');
              if(arr.indexOf(newData[i].pagesNum) == -1){
                e.pagesNum += (',' + newData[i].pagesNum);
              }
            }
          }
        });
      }
      if(!on){
        res = [...res,newData[i]];
      }
    }
    // 保存所有数据
    this.saveSelections(res);
  }

  // 非全文检索时：合并数据
  mergeData2(oldDatas) {
    // 新选择的数据
    let newData = [];
    this.checkedData.forEach(e => {
      const i = parseInt(e);
      newData.push({
        materialId: this.datas[i].materialId,
        pagesNum: ''
      })
    })
    let res = oldDatas;
    for (let i = 0; i < newData.length; i++) {
      let on = false;
      if(res.length > 0){
        res.forEach(e => {
          // 判断是否选择该资源
          if(e.materialId == newData[i].materialId){
            on = true;
            e.pagesNum = '';
          }
        });
      }
      if(!on){
        res = [...res,newData[i]];
      }
    }
    // 保存所有数据
    this.saveSelections(res);
  }

  // 保存所有数据
  saveSelections(res) {
    let arr = [];
    res.forEach(e => {
      let item = {
        materialId: e.materialId,
        pagesNum: e.pagesNum,
        userId: this.userId
      }
      if(e.pagesNum){
        let arr1 = e.pagesNum.split(',').map(e1 => parseInt(e1));
        arr1 = arr1.sort((a, b) => a - b);
        item.pagesNum = arr1.join(',');
      }
      arr.push(item);
    })
    this.kmsService.saveExtractResources(arr).subscribe((res) => {
      this.swMaskService.closeMask();
      if(res["code"] == "200"){
        this.box.success("已添加到提取任务!");
        $('#selectedResourceNum').text(arr.length);
        this.jwt.setToKen("selectedResourceNum",arr.length);
      } else {
        this.box.waring(res.msg);
      }
    });
  }

  // 全选
  clickChecedAll() {
    let br = $("#CheAll")[0].checked;
    $("#UserMaintion1 input[type='checkbox']").prop("checked", br);
    //将选中的数据保存起来
    if (br) {
      var checkedAll = $("#UserMaintion1 input[type='checkbox']:Checked");
      for (let i = 0; checkedAll.length > i; i++) {
        if (this.checkedData.indexOf(checkedAll[i].id) === -1) {
          this.checkedData.push(checkedAll[i].id)
        }
      }
    } else {
      this.checkedData = [];
    }
  }

  // 点击div触发checkbox点击事件
  clickDescBox(i,isDisabled) {
    if(isDisabled){
      return;
    }
    $('#UserMaintion1 .full-item').eq(i).find('input:checkbox').trigger('click');
  }

  // 单选
  clickCheced(index) {
    //禁止冒泡
    event.stopPropagation();
    // 获取当前单选框的状态
    const checkbox = $("#UserMaintion1 input[type='checkbox']").eq(index)[0];
    const isChecked = checkbox.checked; // 当前复选框的选中状态
    if (isChecked) {
      if (this.checkedData.indexOf(checkbox.id) === -1) {
        this.checkedData.push(checkbox.id);
      }
    } else {
      const idx = this.checkedData.indexOf(checkbox.id);
      if (idx !== -1) {
        this.checkedData.splice(idx, 1);
      }
    }
    this.updateSelectAll();
  }

  // 设置全选按钮的选中状态
  updateSelectAll() {
    // 检查是否所有复选框都被选中
    const allChecked = $("#UserMaintion1 input[type='checkbox']").length == $("#UserMaintion1 input[type='checkbox']:checked").length;
    $("#CheAll")[0].checked = allChecked;
  }

  // 添加一个条件
  handleAddFormClick() {
    this.formRows.push({
      withType: this.yesAndno[0].id, // 默认选中第一项
      code: this.attrTypeOptions[0].id, // 默认选中第一项
      keyWord: '',
      matchPattern: this.matchPatterns[0].id // 默认选中第一项
    });
  }

  // 移除一个条件
  handleRemoveFormClick(index: number) {
    if (this.formRows.length > 1) {
      this.formRows.splice(index, 1);
    }
  }

  //获取表格数据
  getData(){
    this.isLoading = true;
    // 全文检索
    if(this.isTextSearch){
      //...
    }
    // 其他属性检索
    else{
      let withType = this.lastQueryParams.attrs.length > 0 ? (this.lastQueryParams.attrs[0].withType === 2 ? 0 : this.lastQueryParams.attrs[0].withType) : 0;
      let params = {
        'current': this.pageBase.current,
        'size': this.pageBase.size,
        "resourceName": this.lastQueryParams.materialTitle,
        "matchPattern": this.matchPattern,
        "withType": withType,
        'textType': this.lastQueryParams.textType,
        "searchBasicParams": this.lastQueryParams.attrs
      }
      let keywords = [];
      if(this.lastQueryParams.materialTitle){
        keywords.push(this.lastQueryParams.materialTitle);
      }
      this.lastQueryParams.attrs.forEach(e => {
        if(e.keyWord){
          keywords.push(e.keyWord);
        }
      })
      this.kmsService.esResourceMatchQuery(params).subscribe(
        res => {
          this.isLoading = false;
          this.checkedData = [];
          if(res.code == 200){
            this.pageBase = res.data;
            this.datas = res.data.records? res.data.records : [];
            if(this.datas.length>0){
              this.datas.forEach(item => {
                item.materialTitle = this.replaceKeyword(item.materialTitle, keywords);
                item.description = item.description ? item.description : '';
                item.description = this.replaceKeyword(item.description, keywords);
                if (item.fileThumbnail) {
                  item['src'] = environment.staticFileUrl + item.fileThumbnail;
                }
                // 处理著录信息
                item.attributes = [];
                if(item.properties){
                  item.attributes = this.getAttrList(item.materialCategory, item.textType);
                  item.attributes.forEach(e => {
                    e.value = item.properties[e.id+'Note'] ? item.properties[e.id+'Note'] : item.properties[e.id];
                    if (e.value) {
                      e.value = this.replaceKeyword(e.value, keywords);
                    }else{
                      e.value = '不详';
                    }
                  });
                }
              })
            }
          }else{
            this.box.waring(res.msg);
          }
        }
      )
    }
  }

  // 替换关键字
  replaceKeyword(str, keywords) {
    if (!str) {
      return '';
    }
    for (let keyword of keywords) {
      let regex = new RegExp(keyword, 'g');
      str = str.replace(regex, `<b>${keyword}</b>`);
    }
    return str;
  }

  // 根据materialCategory和textType获取属性列表
  getAttrList(materialCategory, textType) {
    let attrs = [];
    const item = this.fileCategoryOptions.find(e => e.id == materialCategory);
    if (item) {
      const item1 = item.childs.find(e => e.id == textType);
      if (item1) {
        attrs = item1.recordFileds;
      }else{
        attrs = item.recordFileds;
      }
    }
    return JSON.parse(JSON.stringify(attrs.slice(0,4)));
  }

  // 重置方法
  clickReload() {
    this.materialTitle = '';
    this.textType = this.textTypeOptions[0].id;
    this.attrTypeOptions = JSON.parse(JSON.stringify(this.textTypeOptions[0].recordFileds));
    this.attrTypeOptions.unshift({
      id: 'tags',
      text: '研究主题'
    });
    this.formRows = [
      {
        withType: this.yesAndno[0].id, // 默认选中第一项
        code: this.attrTypeOptions[0].id, // 默认选中第一项
        keyWord: '',
        matchPattern: this.matchPatterns[0].id // 默认选中第一项
      }
    ];
    this.clickSelect();
  }

  // 分页点击方法
  clickPageQuery(event) {
    if(event.current>0){
      this.pageBase['pageNum'] = event.current;
      this.pageBase['pageSize'] = event.size;
      this.getData();
    }
  }

  // 获取一段文本中指定关键词前后的文本，并将关键词用 <b> 标签包裹
  extractContext(text, keyWord) {
    // 去除 HTML 标签
    const cleanText = text.replace(/<[^>]*>/g, '');
    // 查找关键词第一次出现的位置
    const index = cleanText.indexOf(keyWord);
    if (index === -1) {
        return '';
    }
    // 计算截取的起始和结束位置
    const start = Math.max(0, index - 50);
    const end = Math.min(cleanText.length, index + keyWord.length + 50);
    // 截取前后 50 个字符
    const extractedText = cleanText.slice(start, end);
    // 给关键词套上 <span> 标签
    const highlightedText = extractedText.replace(keyWord, `<b>${keyWord}</b>`);
    return highlightedText;
  }

  // 查看详情  type: resource 查看资源详情；content 素材内容浏览
  clickViewDetail(item,type){
    if(type == 'resource'){
      let param = { "upOrAdd": "View", "selectedData": item };
      this.create.createModal(MaterialViewComponent, param);
    }else{
      let params = {
        materialId: item.materialId,
        current: item.pagesNum
      };
      this.router.navigate(['/kms/KnowledgeExtract'], {queryParams: {Title: '素材浏览', selectData: JSON.stringify(params)}});
    }
  }
}
